/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../../utils/constants';

const IDS = {
  TRANSACTIONS_TYPE_INTERESTONESCROWDEPOSIT: 'payments.history.transactions.type.interestOnEscrowDeposit',
  TRANSACTIONS_TYPE_LOANREMOVEDDUETORELEASE: 'payments.history.transactions.type.loanRemovedDueToRelease',
  TRANSACTIONS_TYPE_MORTGAGEPAYMENT: 'payments.history.transactions.type.mortgagePayment',
  TRANSACTIONS_TYPE_PRINCIPALADVANCE: 'payments.history.transactions.type.principalAdvance',
  TRANSACTIONS_TYPE_PRINCIPALCURTAILMENT: 'payments.history.transactions.type.principalCurtailment',
};

const enMessages = {
  [IDS.TRANSACTIONS_TYPE_INTERESTONESCROWDEPOSIT]: 'Interest on Escrow Deposit',
  [IDS.TRANSACTIONS_TYPE_LOANREMOVEDDUETORELEASE]: 'Loan Removed Due To Release',
  [IDS.TRANSACTIONS_TYPE_MORTGAGEPAYMENT]: 'Mortgage Payment',
  [IDS.TRANSACTIONS_TYPE_PRINCIPALADVANCE]: 'Principal Advance',
  [IDS.TRANSACTIONS_TYPE_PRINCIPALCURTAILMENT]: 'Principal Curtailment',
};

const enMurabahaMessages = {
  ...enMessages,
  [IDS.TRANSACTIONS_TYPE_INTERESTONESCROWDEPOSIT]: 'Profit on Escrow Deposit',
  [IDS.TRANSACTIONS_TYPE_LOANREMOVEDDUETORELEASE]: 'Account Removed Due To Release',
  [IDS.TRANSACTIONS_TYPE_MORTGAGEPAYMENT]: 'Murabaha Financing Transaction Payment',
  [IDS.TRANSACTIONS_TYPE_PRINCIPALADVANCE]: 'Current Murabaha Debt Advance',
  [IDS.TRANSACTIONS_TYPE_PRINCIPALCURTAILMENT]: 'Additional Murabaha Payment',
};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
